import { colors, FelaCSS, spacing } from '@bridebook/ui';
import { IThemeProperties } from '@bridebook/web/lib/wedding-website/utils/get-theme-properties';

interface IStyles {
  wrapper: FelaCSS;
  title: FelaCSS;
  subtitle: FelaCSS;
}

const componentStyles: (themeProperties: IThemeProperties) => IStyles = (themeProperties) => ({
  wrapper: {
    padding: `${spacing[6]} 0 ${spacing[10]}`,
    color: colors.space,
    gap: spacing[8],
    textAlign: 'center',
  },
  title: {
    fontFamily: themeProperties.primaryFontStyle.fontFamily,
    fontWeight: themeProperties.primaryFontStyle.fontWeight,
    fontSize: 24,
    lineHeight: 1.4,
    margin: 0,
    textAlign: 'center',

    minWidthMobileLg: {
      fontSize: 48,
    },
  },
  subtitle: {
    fontFamily: themeProperties.primaryFontStyle.fontFamily,
    fontWeight: themeProperties.primaryFontStyle.fontWeight,
    fontSize: 16,
    margin: 0,
    textAlign: 'center',
    paddingVertical: spacing[6],
    minWidthMobileLg: {
      fontSize: 32,
    },
  },
});

export default componentStyles;
